module.exports = "../static/media/banner.5ac4145a.png";